import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import AccountMenu from './AccountMenu';
import { TransactionContext } from '../../context/TransactionProvider';

function HeaderDashBoard() {
  const [navbar, setNavbar] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { balance, loading, error, refreshBalance } = useContext(TransactionContext);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const changeBackground = () => {
    if (window.scrollY >= 10) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeBackground);
    const body = document.querySelector('body');
    if (isOpen) {
      body.classList.add('-is-sidebar-open');
    } else {
      body.classList.remove('-is-sidebar-open');
    }
  }, [isOpen]);

  return (
    <header className={`header -dashboard ${navbar ? 'is-sticky bg-white' : ''}`}>
      <div className="header__container px-30 sm:px-20">
        <div className="-left-side">
          <Link to="/" className="header-logo">
            <img src="/img/general/SP2_logo_black.png" alt="logo icon" />
          </Link>
          {/* End logo */}
        </div>
        {/* End _left-side */}

        <div className="row justify-between items-center pl-20">
          <div className="col-auto">
            <div className="d-flex items-center">
              <button type="button" aria-label="menu" className="d-flex" onClick={handleToggle}>
                <i className="icon-menu-2 text-20" />
              </button>

              <div className="d-flex items-center ml-20">
                <div className="d-flex flex-column">
                  <div className="text-14 text-light-1 fw-500 mb-0">Saldo:</div>
                  <div className="text-16 fw-700 text-dark-1 text-blue-1" style={{ marginTop: -5 }}>
                    <div className="d-flex items-center">
                      {loading && <span>Loading...</span>}
                      {error && <span>Gagal</span>}
                      {!loading && !error && (
                        <span>IDR {balance ? balance.toLocaleString() : 0}</span>
                      )}
                      <span className="text-danger cursor-pointer" onClick={refreshBalance}>
                        <i className="fa fa-refresh ml-10" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End .col-auto */}
          <div className="col-auto">
            <div className="d-flex items-center">
              {/* End header-menu */}

              <div className="row items-center x-gap-5 y-gap-20 pl-20 lg:d-none">
                <div className="col-auto">
                  <button
                    type="button"
                    aria-label="email"
                    className="button -blue-1-05 size-50 rounded-22 flex-center">
                    <i className="icon-email-2 text-20" />
                  </button>
                </div>
                {/* End col-auto */}

                <div className="col-auto">
                  <button
                    type="button"
                    aria-label="notification"
                    className="button -blue-1-05 size-50 rounded-22 flex-center">
                    <i className="icon-notification text-20" />
                  </button>
                </div>
                {/* End col-auto */}
              </div>
              {/* End .row */}

              <div className="pl-15">
                <AccountMenu avatar="https://www.kindpng.com/picc/m/24-248253_user-profile-default-image-png-clipart-png-download.png" />
              </div>
            </div>
            {/* End -flex items-center */}
          </div>
          {/* End col-auto */}
        </div>
        {/* End .row */}
      </div>
      {/* End header_container */}
    </header>
  );
}

export default HeaderDashBoard;
